import "./App.css";
import Main from "./Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./componenets/privacypolicy";
import Scholars from "./componenets/scholars";
import NamKazhagamLegal from "./componenets/NamKazhagamLegal";
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/nam-kazhagam/privacy-policy"
            element={<NamKazhagamLegal policy="privacy" />}
          />
          <Route
            path="/nam-kazhagam/terms-and-condition"
            element={<NamKazhagamLegal policy="terms" />}
          />
          <Route path="/scholar-awards" element={<Scholars />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;
